import axios from "axios";

export default {
  getVendorProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor_product/" + id,
        method: "GET"
      }).then(res => {
        commit('SET_VENDOR_PRODUCT', res.data.payload);
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  getVendorProductList({ commit }, { vendorId, vendor_name, page, search, searchType, perPage, type }) {
    const params = {
      page: page || 0,
      vendor_uuid: vendorId || null,
      // vendor_product_name: vendor_name,
      per_page: perPage || 10,
      type: type || '',
    };

    // if (searchType) {
    //   search = searchType === 'type' ? search : '*' + search + '*'
    //   params[searchType] = search;
    // }

    return axios({
      url: "/vendor_product/list", //?order_by=vendor_product_name&order_dir=desc
      params: params,
      method: "GET"
    })
      .then(res => {
        const { items: vendorProducts, total, per_page } = res.data.payload;
        commit('SET_ALL_VENDOR_PRODUCTS', { vendorProducts, total, per_page });
        return res.data.payload;
      });
  },
  addVendorProduct({ commit }, vendor) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor_product",
        data: vendor,
        method: "POST"
      })
        .then(res => {
          // commit('ADD_VENDOEP_RODUCT')
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  },
  editVendorProduct({ commit }, vendor) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor_product/" + vendor.id,
        data: vendor.vendor,
        method: "PATCH"
      })
        .then(res => {
          commit('EDIT_VENDOR_PRODUCT', res.data.payload)
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  },
  updateVendorProduct({ commit }, fields) {
    commit('UPDATE_VENDOR_PRODUCT', fields);
  },
  deleteVendorProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "vendor_product/" + id,
        method: "DELETE"
      })
        .then(res => {
          commit('REMOVE_VENDOR_PRODUCT', id);
          resolve(res)
        })
        .catch(err => {
          reject(err);
        });
    })
  }
};